import fetch from "isomorphic-fetch";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

type DeleteTaskParams = { taskId: string };
export function deleteTask(params: DeleteTaskParams) {
    return fetch(
        withAccountAuthHeaders(`${apiConf.BACK_URL}/tasks/${params.taskId}`, { method: `DELETE` }),
    );
}
